module.exports = __webpack_public_path__ + "img/15.019d4f76.png";